export enum NotificationStatus {
  HIDDEN = 0,
  SHOW = 1,
}
